import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyResponse } from '@nx-c4g/c4g-models';
import { BaseSurveyStepComponent } from '../base-survey-step/base-survey-step.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'c4g-survey-step-introduction',
  standalone: true,
  encapsulation: ViewEncapsulation.ShadowDom,

  imports: [CommonModule],
  templateUrl: './introduction-survey-step.component.html',
  styleUrls: ['./introduction-survey-step.component.scss']
})
export class IntroductionSurveyStepComponent extends BaseSurveyStepComponent {
  constructor(
    @Inject('stepData') stepData: any,
    @Inject('stepResponse') stepResponse: any,
    @Inject('initialStepResponse') initialStepResponse: any,
    private translate: TranslateService
  ) {
    super(stepData, stepResponse, initialStepResponse);
  }

  getLangValue(mls: { en: string; fr: string }): string {
    const lang = this.translate.currentLang === 'fr' ? 'fr' : 'en';
    return mls?.[lang] || mls?.['en'] || '';
  }

  override async getResponse(): Promise<SurveyResponse | undefined> {
    // Use this.stepData and this.emitResponse in your logic
    // Implement your logic here
    return undefined;
  }
}
